"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GooglePayButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _google_pay_logo = _interopRequireDefault(require("../../../assets/svg/google_pay_logo.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var GooglePayButton = exports.GooglePayButton = function GooglePayButton(_ref) {
  var googlePayButtonLoading = _ref.googlePayButtonLoading,
    renderCustomButton = _ref.renderCustomButton,
    handleCustomButtonClicked = _ref.handleCustomButtonClicked,
    onPaymentInitiated = _ref.onPaymentInitiated;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, googlePayButtonLoading && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mx-auto py-5 px-2 text-center"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fas fa-spinner text-black fa-spin"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: googlePayButtonLoading ? "none" : "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, renderCustomButton && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: handleCustomButtonClicked,
    style: {
      width: 240,
      height: 40,
      backgroundImage: "url(".concat(_google_pay_logo["default"], ")"),
      backgroundColor: "black",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "24.7%",
      borderRadius: "3px",
      display: renderCustomButton ? "block" : "none"
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    id: "gpay-button",
    onClick: onPaymentInitiated,
    style: {
      display: renderCustomButton ? "none" : "block"
    }
  })));
};